import { useMemo } from 'react';
var TableRow = function TableRow(_ref) {
  var row = _ref.row;
  var key = row.key;
  return useMemo(function () {
    return row;
  }, [key]);
};
export default TableRow;